<template>
  <article ref="scrollBox" class="bus_list_wrap home CompareFlightIndex">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">
          <span v-if="selectedFlightList.length == 0">{{depCity}}→{{arrCity}}</span>
          <span v-if="selectedFlightList.length == 1">{{arrCity}}→{{depCity}}</span>
        </div>
        <div class="myHeaderR textalignR">
          <i class="iconfont_new icon-wode1"></i>
        </div>
      </div>
    </header>
    <section class="pages_content">
      <div class="date5ListTop">
        <Row>
          <i-col span="4" class="date5ListTopItem textalignM" v-for="(item,index) in dateArr" :key="item.id"
            v-bind:class="{ date5ListTopItemActive: index == 0 }">
            <div class="date" @click="changeDate(item.date,1)">{{item.date.substring(item.date.length - 5)}}</div>
            <div class="day">{{item.day}}</div>
          </i-col>
          <i-col span="4" class="date5ListTopItem morn textalignM">
            <div class="flexContainer">
              <div class="flexItem1 textalignR">
                更多</br>日期
              </div>
              <div style="margin-top:0.2rem;margin-right:0.2rem;margin-left:0.2rem;">
                <i class="iconfont_new icon-xiangxia1"></i>
              </div>
            </div>
            <input type="date" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;opacity: 0;z-index:10;"
              @change="changeDate" v-model="topDate" />
          </i-col>
        </Row>
      </div>

      <div class="searchTip flexContainer fontSize35">
        <div class="textalignL flexItem1">去程：{{depDate}}</div>
        <div class="textalignR flexItem1" v-if="selectedFlightList.length == 1">返程: {{backDate}}</div>
      </div>

      <div class="hangbanBox" v-if="selectedFlightList.length == 0">
        <Spin v-if="goFlightListLoading">
          <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
          <div class="colorprimary">加载中</div>
        </Spin>

        <div class="hangbanItem" v-for="flightItem in goFlightList" :key="flightItem.id" @click="goDetail(flightItem)" v-if="goFlightList.length > 0 && goFlightList != null">
          <div class="card-item-tag-green">
            <span style="font-size: 20px !important;font-weight: bold;" v-if="flightItem.airCompanyName == '中国国航' && (flightItem.depCityName == '广州'||flightItem.arrCityName == '广州') && (name == 'zsairport')">送车票</span>
            <span style="font-size: 20px !important;font-weight: bold;" v-if="(flightItem.depCityName == '珠海' && flightItem.arrCityName =='北京') || (flightItem.depCityName == '北京' && flightItem.arrCityName =='珠海') && flightItem.airCompanyName == '南方航空' && (name == 'zsairport')">送车票</span>
          </div>
          <div class="flexContainer">
            <div class="flexItem3">
              <div class="flexContainer flight-info-wrap">
                <div class="flexItem1 textalignR">
                  <div class="flight-time">{{flightItem.depTime}}</div>
                  <div class="flight-airport">{{flightItem.depCityName+flightItem.depAirportName+flightItem.depTerminal}}</div>
                </div>
                <div class="icon-arrow"></div>
                <div class="flexItem1">
                  <div class="flight-time">{{flightItem.arrTime}}</div>
                  <div class="flight-airport">{{flightItem.arrCityName+flightItem.arrAirportName+flightItem.arrTerminal}}</div>
                </div>
              </div>
            </div>
            <div class="flexItem1 textalignR">
              <div class="flight-number">
                <dfn>¥</dfn>
                <strong>{{flightItem.fakePrice}}</strong>
                <dfn>起</dfn>
              </div>
              <!-- <div
                class="ticket-right"
              >剩余票:{{flightItem.policyItem.cabin[0].ticketCount=="A" ? '>9':flightItem.policyItem.cabin[0].ticketCount}}</div>-->
            </div>
          </div>
          <div class="flexContainer">
            <div class="flexItem1">
              <div class="flight-plane">
                <img :src="flightItem.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
                {{flightItem.airCompanyName}} {{flightItem.flightNo}}
              </div>
            </div>
            <div class="textalignR">
              <div class="flight-plane tag-advantage">
                <span v-if="flightItem.isHasMeal==1" style="margin-right:5px;">
                  <i class="iconfont_new icon-canyin flight-planeIcon"></i>&nbsp;有餐食
                </span>
                <span v-if="flightItem.stopNum==0">
                  <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>&nbsp;直飞
                </span>
                <span v-else>
                  <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
                  &nbsp;经停{{flightItem.stopNum}}次
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hangbanBox" v-if="selectedFlightList.length == 1">
        <Spin v-if="backFlightListLoading">
          <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
          <div class="colorprimary">加载中</div>
        </Spin>
        <div class="hangbanItem" v-for="flightItem in backFlightList" :key="flightItem.id" @click="goDetail(flightItem)" v-if="backFlightList.length > 0 && backFlightList != null">
          <div class="card-item-tag-green">
            <span style="font-size: 20px !important;font-weight: bold;" v-if="flightItem.airCompanyName == '中国国航' && (flightItem.depCityName == '广州'||flightItem.arrCityName == '广州') && (name == 'zsairport')">送车票</span>
            <span style="font-size: 20px !important;font-weight: bold;" v-if="(flightItem.depCityName == '珠海' && flightItem.arrCityName =='北京') || (flightItem.depCityName == '北京' && flightItem.arrCityName =='珠海') && flightItem.airCompanyName == '南方航空' && (name == 'zsairport')">送车票</span>
          </div>
          <div class="flexContainer">
            <div class="flexItem3">
              <div class="flexContainer flight-info-wrap">
                <div class="flexItem1 textalignR">
                  <div class="flight-time">{{flightItem.depTime}}</div>
                  <div class="flight-airport">{{flightItem.depCityName+flightItem.depAirportName+flightItem.depTerminal}}</div>
                </div>
                <div class="icon-arrow"></div>
                <div class="flexItem1">
                  <div class="flight-time">{{flightItem.arrTime}}</div>
                  <div class="flight-airport">{{flightItem.arrCityName+flightItem.arrAirportName+flightItem.arrTerminal}}</div>
                </div>
              </div>
            </div>
            <div class="flexItem1 textalignR">
              <div class="flight-number">
                <dfn>¥</dfn>
                <strong>{{flightItem.fakePrice}}</strong>
              </div>
            </div>
          </div>

          <div class="flexContainer">
            <div class="flexItem1">
              <div class="flight-plane">
                <img :src="flightItem.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
                {{flightItem.airCompanyName}} {{flightItem.flightNo}}
              </div>
            </div>
            <div class="textalignR">
              <div class="flight-plane tag-advantage">
                <span v-if="flightItem.isHasMeal==1" style="margin-right:5px;">
                  <i class="iconfont_new icon-canyin flight-planeIcon"></i>&nbsp;有餐食
                </span>
                <span v-if="flightItem.stopNum==0">
                  <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>&nbsp;直飞
                </span>
                <span v-else>
                  <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
                  &nbsp;经停{{flightItem.stopNum}}次
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
  import scopeApi from "../request/scopeApi";
  import flightApi from "../request/flightApi";
  import {
    mapState
  } from "vuex";
  import baseTool from "../utils/baseFunction";
  export default {
    name: "FlightNoList",
    data() {
      return {
        name: "", // 商户标识

        // 标题
        from: "北京",
        to: "南京",

        // 查询的日期
        selectDay: "08-05",
        topDate: null,
        //显示多少天日期title
        longDay: 5,
        dateArr: [],

        goFlightList: null,
        backFlightList: null,

        goFlightListLoading: false,
        backFlightListLoading: false,

        IsGoBack: '',
      };
    },
    components: {},
    activated: function() {
		let that = this;
    console.log(this.$store.state.flight)
      if (this.$route.params.name && this.$route.params.name.length) {
        this.name = this.$route.params.name;
        this.IsGoBack = parseInt(this.$route.params.IsGoBack)
      }

      if (this.flightType == 1 || this.IsGoBack == 0) {
        if (this.selectedFlightList && this.selectedFlightList != null && this.selectedFlightList != undefined && this.selectedFlightList.length > 0) {
          this.$store.commit("flight/setFlightQueryCondition", {
            selectedFlightList: []
          });
        }
        if (this.selectedFlightList && this.selectedPolicyList != null && this.selectedFlightList != undefined && this.selectedPolicyList.length > 0) {
          this.$store.commit("flight/setFlightQueryCondition", {
            selectedPolicyList: []
          });
        }
      } else if (this.flightType == 2 && this.IsGoBack == 1) {
        if (this.selectedFlightList && this.selectedFlightList != null && this.selectedFlightList != undefined && this.selectedFlightList.length > 1) {
          this.$store.commit("flight/setFlightQueryCondition", {
            selectedFlightList: [that.selectedFlightList[0]]
          });
        }
        if (this.selectedFlightList && this.selectedPolicyList != null && this.selectedFlightList != undefined && this.selectedPolicyList.length > 1) {
          this.$store.commit("flight/setFlightQueryCondition", {
            selectedPolicyList: [that.selectedFlightList[0]]
          });
        }
      }
	  console.log('selectedFlightList->',this.selectedFlightList);
	  // if (this.ifBackRefresh) {
	    if (this.selectedFlightList.length == 0) {
        // if(this.goFlightList.length == 0){
          this.getDepFlightList();
        // }
	      this.selectDay = this.depDate;
	      this.countDate(new Date(this.depDate), this.longDay);
	    }
	    if (this.selectedFlightList.length == 1) {
        // if(this.backFlightList.length == 0){
          this.getBackFlightList();
        // }
	      this.selectDay = this.backDate;
	      this.countDate(new Date(this.backDate), this.longDay);
	    }
	  // }

    },
    created() {},
    mounted() {
	    // if (this.selectedFlightList.length == 0) {
     //    this.getDepFlightList();
	    //   this.selectDay = this.depDate;
	    //   this.countDate(new Date(this.depDate), this.longDay);
	    // }
	    // if (this.selectedFlightList.length == 1) {
	    //   this.getBackFlightList();
	    //   this.selectDay = this.backDate;
	    //   this.countDate(new Date(this.backDate), this.longDay);
	    // }
    },
    computed: mapState({
      isDep: (state) => state.flight.isDep,
      airLineCode: (state) => state.flight.airLineCode,
      depDate: (state) => state.flight.depDate,
      backDate: (state) => state.flight.backDate,
      depCity: (state) => state.flight.depCity,
      depCityPortCode: (state) => state.flight.depCityPortCode,
      arrCity: (state) => state.flight.arrCity,
      arrCityPortCode: (state) => state.flight.arrCityPortCode,
      airCompanyCode: (state) => state.flight.airCompanyCode,
      airCompanyName: (state) => state.flight.airCompanyName,
      flightType: (state) => state.flight.flightType,
      psgType: (state) => state.flight.psgType,
      cabinRank: (state) => state.flight.cabinRank,
      directFlight: (state) => state.flight.directFlight,
      selectedFlightList: (state) => state.flight.selectedFlightList,
      selectedPolicyList: (state) => state.flight.selectedPolicyList,
      ifBackRefresh: (state) => state.flight.ifBackRefresh,
      OpenId: (state) => state.user.OpenId,

      gzCityPortCode: (state) => state.flight.gzCityPortCode,
      szCityPortCode: (state) => state.flight.szCityPortCode,
      zhCityPortCode: (state) => state.flight.zhCityPortCode,
    }),
    methods: {

      getBusinessInfo() {
        //获取商户信息
        businessApi.getBusinessInfo(this.name).then(res => {
          if (res.success) {
            this.businessInfo = res.data;
            this.$store.commit('appoint/setData', {
              businessSign: this.name
            }); // new
          }
        });
      },

      changeDate(date, key) {
        //如果传了key为1，需要转格式：
        if (key == 1) {
          this.topDate = this.changeTime1toMMDD(date);
        }
        if (this.topDate != "" || this.topDate != null) {
          if (this.selectedFlightList.length == 0) {
            if (this.flightType == 2 && this.topDate >= this.backDate) {
              this.$Message.warning("往返套票出发日期不得晚于返程日期。");
              return;
            }

            this.$store.commit("flight/setFlightQueryCondition", {
              depDate: this.topDate,
            });

            this.getDepFlightList();
            this.selectDay = this.depDate;
            this.countDate(new Date(this.depDate), this.longDay);
          }
          if (this.selectedFlightList.length == 1) {
            if (this.flightType == 2 && this.topDate <= this.depDate) {
              this.$Message.warning("往返套票出发日期不得晚于返程日期。");
              return;
            }

            this.$store.commit("flight/setFlightQueryCondition", {
              backDate: this.topDate,
            });

            this.getBackFlightList();
            this.selectDay = this.backDate;
            this.countDate(new Date(this.backDate), this.longDay);
          }
        }
      },
      //计算传入的日期，显示后5天日期：
      countDate(res, longDay) {
        let nowadays = this.changeTime1toMMDD(res); //当前选择的那天
        let dayList = [{
          id: 0,
          date: nowadays,
          day: this.getDay(res)
        }];
        for (let i = 1; i < longDay; i++) {
          let t = new Date(res.getTime() + 24 * 60 * 60 * 1000 * i);
          let d = this.getDay(t);
          t = this.changeTime1toMMDD(t);
          dayList.push({
            id: i,
            date: t,
            day: d
          });
        }
        this.dateArr = dayList;
      },
      //标准时间格式转为YYYY MM-DD
      changeTime1toMMDD(res) {
        let d = new Date(res);
        let YYYY = d.getFullYear();
        let M = d.getMonth() + 1;
        let MM = M >= 10 ? M : "0" + M;
        let D = d.getDate();
        let DD = D >= 10 ? D : "0" + D;
        let localDate = YYYY + "-" + MM + "-" + DD;
        return localDate;
      },
      //获取星期几：
      getDay(res) {
        var myDate = new Date(res);
        var days = myDate.getDay();
        switch (days) {
          case 1:
            days = "星期一";
            break;
          case 2:
            days = "星期二";
            break;
          case 3:
            days = "星期三";
            break;
          case 4:
            days = "星期四";
            break;
          case 5:
            days = "星期五";
            break;
          case 6:
            days = "星期六";
            break;
          case 0:
            days = "星期日";
            break;
        }
        return days;
      },
      //跳转：
      goDetail(data) {
        if (data.policys.length == 0) {
          this.$Message.error("无法获取该航班舱位信息！");
          return;
        }
        let selectedFlightList = [...this.selectedFlightList];
        selectedFlightList.push(data);

        this.$store.commit("flight/setFlightQueryCondition", {
          selectedFlightList: selectedFlightList,
          ifBackRefresh: true,
        });

        this.$router.push({
          name: "FlightNoDetail",
          params: {
            name: this.name,
            IsGoBack: this.IsGoBack
          },
        });
      },

      // clearLast(){
      //   // let selectedFlightList = [...this.selectedFlightList];
      //   // selectedFlightList.pop();

      //   // this.$store.commit('flight/setFlightQueryCondition', {
      //   //   selectedFlightList: selectedFlightList
      //   // });
      //   this.$router.go(-1);
      // },

      getDepFlightList() {
        let that = this;
        this.goFlightList = [];
        this.goFlightListLoading = true;
        flightApi
          .getFlightList(
            this.flightType,//往返-单1/双2
            this.cabinRank,//0
            this.psgType,//1
            this.depCityPortCode,
            this.arrCityPortCode,
            this.depDate,
            this.airCompanyCode,
          )
          .then((sucRes) => {
            this.goFlightListLoading = false;
            console.log(sucRes);
            if (sucRes.success) {
              sucRes.data.forEach((obj) => {
                let depInfoTime = obj.depDate + " " + obj.depTime;
                let nowTime = baseTool.dateFormat(new Date(), "yyyy-MM-dd HH:mm");
                if (nowTime > depInfoTime) {
                  obj.isTimeOut = true;
                } else {
                  obj.isTimeOut = false;
                }
                obj.isShowList = false; // 是否展开政策、仓位
                obj.fakePrice =
                  obj.policys[0] && obj.policys[0].priceDatas[0] ?
                  obj.policys[0].priceDatas[0].price :
                  " - ";

                obj.policys.forEach((pol) => {
                  pol.isSelected = false; // 选中政策，默认没选
                  pol.chaRule = null; // 改签规则，默认空，要先请求后保存。
                  pol.refRule = null; // 退票规则，默认空，要先请求后保存。
                });
              });

              this.goFlightList = sucRes.data;
            } else {
              this.$Message.error(sucRes.message);
              this.$router.go(-1);
            }
          });
      },

      getBackFlightList() {
        let that = this;
        this.backFlightList = [];
        this.backFlightListLoading = true;
        flightApi
          .getFlightList(
            this.flightType,
            this.cabinRank,
            this.psgType,
            this.arrCityPortCode,
            this.depCityPortCode,
            this.backDate,
            this.airCompanyCode,
          )
          .then((sucRes2) => {
            this.backFlightListLoading = false;
            if (sucRes2.success) {
              sucRes2.data.forEach((obj) => {
                obj.isShowList = false; // 是否展开政策、仓位
                obj.fakePrice =
                  obj.policys[0] && obj.policys[0].priceDatas[0] ?
                  obj.policys[0].priceDatas[0].price :
                  " - ";
                obj.policys.forEach((pol) => {
                  pol.isSelected = false; // 选中政策，默认没选
                  pol.chaRule = null; // 改签规则，默认空，要先请求后保存。
                  pol.refRule = null; // 退票规则，默认空，要先请求后保存。
                });
              });
              this.backFlightList = sucRes2.data;
            } else {
              this.$Message.error(sucRes2.message);
              this.$router.go(-1);
            }
          });
      },
    },
  };
</script>

<style scoped lang="less">
  @import "../style/home.less";

  .pages_title {
    background-color: transparent;
    padding: 0;
    color: #fff;
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/FlightNoList.vue